"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.useDebouncedState = useDebouncedState;
var _react = require("react");
/**
 *  This hook takes a value prop as input and returns a
 * "debouncedState" and "waiting" indicator.
 * When the props change, the hook sets "waiting" to true and
 * sets a timer for 500ms to update the "debouncedState".
 * If props change before the timer expires, it cancels the previous timer and starts a new one.
 * This ensures that the "debouncedState" only reflects the latest value after a 500ms delay.
 */
const DEBOUNCE_TIMEOUT = 500;
function useDebouncedState(initialValue) {
  const [debouncedState, setDebouncedState] = (0, _react.useState)(initialValue);
  const [waiting, setWaiting] = (0, _react.useState)(false);
  (0, _react.useEffect)(() => {
    const timer = setTimeout(() => {
      setDebouncedState(initialValue);
      setWaiting(false);
    }, DEBOUNCE_TIMEOUT);
    setWaiting(true);
    // Clean up the timer on unmount or when initialValue changes
    return () => clearTimeout(timer);
  }, [initialValue]);
  return {
    debouncedState,
    waiting
  };
}
var _default = exports.default = useDebouncedState;